import React from 'react';

import QuestionLabel from './Components/QuestionLabel';

export default function PhotoProperties({ question }) {
  return <QuestionLabel question={question} />
};